'use strict';
(function () {
  angular.module('pentaApp').factory('queueAttending.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/queueAttending');
  }
})();
